<template>
  <div class="experience-list-content">
    <template v-for="(item, index) in experienceData">
      <div class="experience flex" :key="index" @click="changeChecked(item)" v-if="showBox || item.checked">
        <span v-show="showDelete" class="iconfont iconshanchujianli" @click.stop="deleteExperience(item)"></span>
        <input v-if="showBox && !showDelete" type="checkbox" class="w-radio experience-box" :checked="item.checked">
        <div class="experience-item" :class="{'experience-item-checked': item.checked}">
          <p class="experience-name" v-if="title(item)">{{title(item)}}</p>
          <div class="experience-info" v-if="infoShow(item)">
            <span class="flex-start" v-if="item.city">{{ item.city }}</span>
            <span class="flex-start" v-if="item.major">{{item.major}}</span>
            <span class="flex-start" v-if="item.degree">{{item.degree}}</span>
            <span class="flex-start" v-if="item.dept">{{ item.dept }}</span>
            <span class="flex-start" v-if="item.uni_school">{{item.uni_school}}</span>
            <span class="flex-start" v-if="item.title"> {{ item.title }}</span>
          </div>
          <div class="experience-time" v-if="item.start_at || item.end_at || item.present">
            <span v-if="item.start_at">{{item.start_at | timeFilter('YYYY.MM')}}</span>
            <span v-if="item.start_at && (item.end_at || item.present)"> - </span>
            <span v-if="item.end_at">{{item.end_at | timeFilter('YYYY.MM')}}</span>
            <span v-if="item.present">{{item.present}}</span>
          </div>
          <div class="experience-description" :class="{'list-description': !showBox}" v-if="item.description"
               v-html="item.description"></div>
          <p class="experience-update-time flex-end">更新于：{{ item.updated_at | timeFormatFilter }}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
	import { addClass, removeClass } from '../../assets/js/dom'

	export default {
		name: 'experience-item',
		props: {
			showBox: {
				type: Boolean,
				default: false
			},
			experienceData: {
				type: Array,
				default: () => []
			},
			showDelete: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {},
		methods: {
			deleteExperience (item) {
				this.$emit('deleteExperience', item)
			},
			changeChecked (item) {
				if (!this.showDelete) {
					this.$emit('changeCheck', item, this.experienceData)
				}
			},
			// 经历的title
			title (info) {
				return info.university || info.company || info.name
			},
			// info 是否显示问题
			infoShow (info) {
				let fields = [ 'city', 'major', 'degree', 'dept', 'uni_school', 'title' ]
				for (let i = 0; i < fields.length; i++) {
					if (info[fields[i]]) return true
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/global/variable';
  @import '../../assets/scss/global/mixin';
  .experience {
    background-color: #f9f9f9;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 12px;
    position: relative;
    .iconshanchujianli {
      position: absolute;
      right: 20px;
      color: #9c9c9c;
      font-size: 16px;
      top: 23px;
      font-weight: 600;
    }
    &:first-child {
      margin-top: 24px
    }
    &:last-child {
      margin-bottom: 0;
    }
    .experience-box {
      flex-shrink: 0;
      width: 12px;
      height: 12px;
      border-color: #9c9c9c !important;
      margin-top: 6px;
      &::after {
        background-color: $color-dark-gray;
      }
    }
    .experience-item {
      flex: 1;
      color: #9c9c9c;
      .experience-name {
        font-size: $font-size-medium-x;
        line-height: 24px;
        margin-bottom: 14px;
        font-weight: 500;
        max-width: 96%;
        word-break: break-all;
      }
      .experience-info {
        /*flex-wrap: wrap;*/
        margin-bottom: 10px;
        @include ellipsis(calc(100vw - 88px));
        span {
          display: inline;
          line-height: 18px;
        }
        span:before {
          content: '';
          display: inline-block;
          width: 1px;
          height: 14px;
          background-color: #9c9c9c;
          margin: 0 6px;
        }
        span:first-child:before {
          display: none;
        }
      }
      .experience-time {
        margin-top: 10px;
        margin-bottom: 12px;
      }
      .experience-update-time {
        margin-top: 12px;
        font-size: $font-size-small;
        margin-bottom: 8px;
      }
      .experience-description {
        color: #9c9c9c;
        line-height: 22px;
        /deep/ li {
          list-style: inside;
        }
      }
      .experience-description-hide {
        height: 88px;
        overflow: hidden;
      }
    }
    .experience-item-checked {
      color: $color-dark-gray;
      .experience-info {
        span:before {
          background-color: $color-dark-gray;
        }
      }
      .experience-description {
        color: $color-dark-gray;
        word-break: break-all;
      }
    }
    .list-description {
      position: relative;
      height: 88px;
      overflow: hidden;
      &:after {
        content: '...';
        position: absolute;
        right: 0;
        bottom: 0;
        background-color: #f9f9f9;
      }
    }
    /*.list-description {*/
    /*  overflow: hidden;*/
    /*  text-overflow: ellipsis;*/
    /*  display: -webkit-box; //作为弹性伸缩盒子模型显示。*/
    /*  -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列*/
    /*  -webkit-line-clamp: 4; //显示的行*/
    /*}*/
  }
</style>
